import { NameDto } from '../../Common/Types'
import { TransactionDirectionType } from '../../Transaction/Types/TransactionDirectionType'
import { CurrencyType } from '../../Wallet/Types/Wallet'
import { WalletCurrencyDto } from '../../Wallet/Types/WalletCurrencyDto'
import { WalletTypeDto } from '../../Wallet/Types/WalletTypeDto'

export interface NPaymentProviderDto {
  id: string
  name: string
  provider: NameDto<string>
  category: NameDto
  service: NameDto
  processor: NameDto<string>
  depositAutomationType: NameDto
  withdrawAutomationType: NameDto
  imported: boolean
  enabled: boolean
  created: string
  updated: string
  methodConfigurations: NPaymentProviderMethodConfiguration[]
  methodParameters: {
    id: string
    name: string
    parameterType: NameDto
    configurationType: NameDto
    fieldName: 'external_account'
    value: null
    caller: 'bo'
    mandatory: boolean
    clientFilled: boolean
    systemFilled: boolean
    enabled: boolean
    ordering: number
    skipTranslate: boolean
    selectOptions: []
  }[]
  methodDefaults: NPaymentProviderMethodDefault[]
  textData: {
    id: string
    configurationType: NameDto
    description: string
    fundingTime: string
    regulator: null
    fee: string
    maintenanceMessage: null
    listingDescription: null
    skipTranslate: boolean
  }[]
  additionalTextData: []
  languages: NameDto<string>[]
}

export interface NPaymentProviderMethodConfiguration {
  id?: string
  walletType: WalletTypeDto
  walletCurrency: NameDto<CurrencyType>
  country?: NameDto<string>
  selected?: boolean // for kendoui purposes
}

export interface NPaymentProviderMethodDefault {
  id?: string // for formik purposes
  walletType: WalletTypeDto
  configurationType: TransactionDirectionType
  paymentCurrency: WalletCurrencyDto
  minimumAmount: number
  maximumAmount: number
  enabled: boolean
  maintenance: boolean
  automatic?: boolean
  emails?: boolean
  apiBased?: boolean
  acceptedDecimals?: null
  created?: string
  updated?: string
}

export enum PaymentProviderOverviewKey {
  name = 'provider.name',
  description = 'description',
  method = 'name',
  enabled = 'enabled',
  walletType = 'walletType.name',
  paymentCurrency = 'paymentCurrency.id',
  configurationType = 'configurationType.name',
  minimumAmount = 'minimumAmount',
  maximumAmount = 'maximumAmount',
  maintenance = 'maintenance',
  walletCurrency = 'walletCurrency.id',
  country = 'country.name',
}
